import styled from 'styled-components';

const PrivacyPage = () => {
  return (
    <Container>
      <Heading>Privacy Policy (You Matter)</Heading>

      <SectionTitle>1. Introduction</SectionTitle>
      <Paragraph>
        Anahex ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy outlines the types of data we collect, how we use it, and your rights as a user.
      </Paragraph>

      <SectionTitle>2. Data We Collect</SectionTitle>
      <Paragraph>
        We collect the following user data:
        <ul>
          <li>Name</li>
          <li>Email address (AES encrypted)</li>
          <li>Whatsapp number (AES encrypted)</li>
          <li>Linkedin profile URL (AES encrypted)</li>
          <li>Company / Institution</li>
          <li>Designation</li>
          <li>Device metadata and product usage patterns</li>
          <li>Purchase history (we do not store bank account, card information, or UPI details)</li>
        </ul>
      </Paragraph>

      <SectionTitle>3. Purpose of Data Usage</SectionTitle>
      <Paragraph>
        Your data is used to:
        <ul>
          <li>Personalize Questions</li>
          <li>Provide transactional communications (e.g., OTP, reminders)</li>
          <li>Improve platform performance and detect misuse</li>
        </ul>
      </Paragraph>

      <SectionTitle>4. Data Storage & Residency</SectionTitle>
      <Paragraph>
        All user data is stored securely on servers located within India. We do not use foreign data centers. Data is encrypted both at transit and at rest.
        <br/>
      </Paragraph>

      <SectionTitle>5. Data Sharing</SectionTitle>
      <Paragraph>
        We use third party Whatsapp/Email Communication providers for Sending Daily Message, OTP and communication.
        Data is never sold, rented, or disclosed unless legally required.

        <ul>
            <li><a href="https://aisensy.com/privacy-policy">Aisensy Policies</a></li>
            <li><a href="https://www.gupshup.ai/privacy-policy">Gupshup Policies</a></li>
            <li><a href="https://www.brevo.com/legal/privacypolicy/">Brevo Policies</a></li>
            <li><a href="https://policies.google.com/privacy">Firebase Policies</a></li>
            <li><a href="https://www.whatsapp.com/legal/">WhatsApp Policies</a></li>
        </ul>
      </Paragraph>

      <SectionTitle>6. User Control & Deletion</SectionTitle>

      <SectionSubTitle>6.1 Account Deletion</SectionSubTitle>
      <Paragraph>
        Users can delete account by sending "delete my account" in whatsapp chat. Once received, the following data is permanently deleted within 15 days:
        <ul>
          <li>User-provided information including personal details, preferences</li>
        </ul>
      </Paragraph>

      <SectionSubTitle>6.2 Retained Data</SectionSubTitle>
      <Paragraph>
        The following data may be retained even after account deletion:
        <ul>
          <li>Payment transaction records (we do not store bank account, card information, or UPI details)</li>
          <li>Associated contact details</li>
          <li>Derived activity logs such as answers, interactions</li>
        </ul>
      </Paragraph>

      <SectionSubTitle>6.3 Platform Conduct</SectionSubTitle>
      <Paragraph>
        We urge users to treat others on the platform with respect and dignity. We request users not to share any personally identifiable or sensitive information with other users.
      </Paragraph>

      <SectionSubTitle>6.4 Inactive Users & Refunds</SectionSubTitle>
      <Paragraph>
        All inactive users i.e. users who are not responding to questions are automatically purged after <strong>account validity period + 6 months</strong>. This is considered equivalent to account deletion.
      </Paragraph>
      <Paragraph>
        Users are advised to top up only what they can reasonably consume in the short term. We do not offer refunds.
      </Paragraph>

      <SectionSubTitle>6.5 Safety & Community Protection</SectionSubTitle>
      <Paragraph>
        Additionally, we want to state clearly that the intent of using Anahex is strictly for individuals seeking knowledge, growth, upskill.
      </Paragraph>
      <Paragraph>
        Unfortunately, there are more scammers than we realize—posing as government officials, business owners, or creating and misleading information. Please stay vigilant and report any such users immediately.
      </Paragraph>
      <Paragraph>
        In the event of any misconduct, we stand by your right to safety and will fully cooperate with local authorities when required. Please take care and stay safe.
      </Paragraph>

      <SectionTitle>7. Minimum Age</SectionTitle>
      <Paragraph>
        You must be at least 18 years old to use Anahex.
      </Paragraph>

      <Paragraph>
        We exist to empower one in need. Beyond this document, on moral and ethical ground, we are with you.
        Our goal is not just to provide a safe digital space, but to stand by every individual who is seeking genuine learning opportunity with trust and care. If you ever find yourself feeling unsure, unsafe, or unheard—please reach out. We respect those who respect themselves and their surrounding. This platform is built not just on code and compliance, but on the belief that human dignity and support must come first.
      </Paragraph>

      <SectionTitle>8. Jurisdiction</SectionTitle>
      <Paragraph>
        Anahex is based in Bengaluru, Karnataka, India and adheres to Indian data protection laws including the Digital Personal Data Protection Act, 2023. Any legal proceedings, disputes, or claims arising out of the use of this application shall fall under the exclusive jurisdiction of the courts located in Bengaluru, Karnataka. By continuing to use Anahex, you agree that any legal proceedings, disputes, or claims related to our product/platform will be subject to the exclusive jurisdiction of the courts located in Bengaluru, Karnataka. We will not be obligated to appear or respond to legal matters filed in any jurisdiction outside Bengaluru. This means that if any legal notice, summons, or action is issued outside Bengaluru, we are not obligated to be present or engage with such proceedings outside the designated jurisdiction. You and Anahex mutually agree that any legal disputes must be filed only in the competent courts of Bengaluru, Karnataka. If legal action is filed elsewhere, Anahex reserves the right not to participate. Only cases initiated by Anahex may be filed outside this jurisdiction.
      </Paragraph>

      <SectionTitle>9. Local Storage</SectionTitle>
      <Paragraph>
        Only necessary application data is stored locally for website functionality. No cookies or trackers are used.
      </Paragraph>

      <SectionTitle>10. Consent & Communication</SectionTitle>
      <Paragraph>
        By registering, you consent to receiving essential notifications (e.g., OTP, questions, reminders). You may opt-out of promotional messages at any time.
      </Paragraph>

      <SectionTitle>12. Children's Privacy</SectionTitle>
      <Paragraph>
        Anahex is not intended for individuals under 18. We do not knowingly collect data from minors. If such data is identified, it will be promptly deleted.
      </Paragraph>

      <SectionTitle>13. Policy Updates</SectionTitle>
      <Paragraph>
        This Privacy Policy may be updated from time to time. Continued use of the platform constitutes acceptance of those changes. If you do not agree with any part of this Privacy Policy, please stop using the product immediately and reach out to us at <a href="mailto:policy@anahex.com">policy@anahex.com</a>.
      </Paragraph>

      <Paragraph><em>Last updated: Jan 29, 2026</em></Paragraph>

<Paragraph>
        For any such disputes where you need our assistance, please write to us at <a href="mailto:support@anahex.com">support@anahex.com</a>.
      </Paragraph>

      <Paragraph>
        For privacy concerns or data requests, please contact us at: <a href="mailto:policy@anahex.com">policy@anahex.com</a>.
      </Paragraph>
    </Container>
  );
};

const Container = styled.div`
  padding: 40px 20px;
  max-width: 800px;
  margin: auto;
  background: #fff;
  font-family: 'Helvetica Neue', sans-serif;
`;

const Heading = styled.h1`
  font-size: 32px;
  font-weight: bold;
  color: #000;
  margin-top: 56px;
  margin-bottom: 24px;
`;

const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin-top: 32px;
  margin-bottom: 12px;
  color: #333;
`;

const SectionSubTitle = styled.h3`
  font-size: 17px;
  font-weight: 600;
  margin-top: 24px;
  margin-bottom: 8px;
  color: #333;
`;

const Paragraph = styled.div`
  font-size: 16px;
  line-height: 1.6;
  color: #444;

  ul {
    padding-left: 20px;
    margin: 8px 0;
  }

  li {
    margin-bottom: 6px;
  }
`;

export default PrivacyPage;
